import React from 'react';
import classNames from 'classnames';

import { ReactComponent as Building } from 'assets/images/icons/building.svg';

type Props = {
  name: string;
};

export const ObjectCard: React.FC<Props> = ({ name }) => {
  return (
    <div className={classNames('dashboard-object-card')}>
      <div className={classNames('dashboard-object-card__icon')}>
          <Building />
      </div>
      <span className={classNames('dashboard-object-card__name')}>{name}</span>
    </div>
  );
};
